import { takeLatest, call, put } from 'redux-saga/effects';

import { checkIfAPIResponseIsSuccess } from 'utils/functions/general';

import { getPendingClosedCircles, changeClosedCircleStatus } from './api';
import {
  fetchPendingClosedCirclesSuccess,
  fetchPendingClosedCirclesFail,
  fetchChangeCircleStatusSubmissionSuccess,
  fetchChangeCircleStatusSubmissionFail,
} from './actions';
import circlesActionTypes from './action-types';

function* fetchPendingClosedCirclesSuccessSaga({ payload }) {
  try {
    const response = yield call(getPendingClosedCircles, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    yield put(fetchPendingClosedCirclesSuccess(response.data.data));
  } catch (error) {
    yield put(fetchPendingClosedCirclesFail(error));
  }
}

function* fetchChangeCircleStatusSubmissionSaga({ payload }) {
  const { actionPopupCallbackAction } = payload;

  try {
    const response = yield call(changeClosedCircleStatus, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    actionPopupCallbackAction(true);
    yield put(fetchChangeCircleStatusSubmissionSuccess(response.data.data));
  } catch (error) {
    actionPopupCallbackAction();
    yield put(fetchChangeCircleStatusSubmissionFail(error));
  }
}

function* circlesSaga() {
  yield takeLatest(
    circlesActionTypes.FETCH_PENDING_CLOSED_CIRCLES,
    fetchPendingClosedCirclesSuccessSaga,
  );
  yield takeLatest(
    circlesActionTypes.FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION,
    fetchChangeCircleStatusSubmissionSaga,
  );
}

export default circlesSaga;
